// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const creditLinkage = "CreditLinkage__creditLinkage__eusaq";
export const formButtonContainer = "CreditLinkage__formButtonContainer__Xq0IZ";
export const formButtonContainerFirst = "CreditLinkage__formButtonContainerFirst__1qtXi";
export const content = "CreditLinkage__content__PZs3o";
export const subtitleHighlighted = "CreditLinkage__subtitleHighlighted__m6hJ7";
export const subtitleHighlightedAnimation = "CreditLinkage__subtitleHighlightedAnimation__ItGH1";
export const spinner = "CreditLinkage__spinner__KIGpT";
export const spinnerBlockWrapper = "CreditLinkage__spinnerBlockWrapper__YMny7";
export const spinnerWrapper = "CreditLinkage__spinnerWrapper__484Hu";
export const spinnerCaption = "CreditLinkage__spinnerCaption__AZkxA";
export const errorButtons = "CreditLinkage__errorButtons__LMUkt";
export const errorButtonContainer = "CreditLinkage__errorButtonContainer__Zpp+L";
export const transunionBadge = "CreditLinkage__transunionBadge__MIVLc";
export const subheaderParagraph = "CreditLinkage__subheaderParagraph__nWUrb";